import { createApp } from 'vue';
import AviToMp3Converter from '@/Components/AviToMp3Converter.vue';
import '@styles/app.css';

createApp(AviToMp3Converter).mount('#avi-to-mp3-converter');
